import { CommonMessage } from "../../types";
import { EventBody, MessageComponent, MessageComponentProps } from "./Message";
import { HighlightedText } from "../../agent/stateComponents/SimpleComponentVisualization";

const RawMessage: MessageComponent<CommonMessage> = ({
  message,
  textFilter,
}: MessageComponentProps<CommonMessage>) => {
  // Shallow-copy the message, then drop the top-level fields we don't want
  // to display before stringifying.
  const trimmedMessage: Partial<CommonMessage> = { ...message };
  delete trimmedMessage.agency_tags;
  delete trimmedMessage.channels;
  delete trimmedMessage.ignorable;
  delete trimmedMessage.message_type;
  delete trimmedMessage.sender;
  delete trimmedMessage.source;

  return (
    <EventBody>
      <HighlightedText
        text={JSON.stringify(trimmedMessage, null, 2)}
        textFilter={textFilter}
      />
    </EventBody>
  );
};

export default RawMessage;
